var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 300,
    y: 300,
    fill: "#00A1DE "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 300,
    fill: "#ed2939"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 200,
    y: 200,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLu);
export default __webpack_public_path__ + "static/media/lu.c83e3405a709627edec8b687db4601a5.svg";
export { ForwardRef as ReactComponent };